import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { EmployeeRoleService } from '../../../core/services/employee/employee-role/employee-role.service'
import { OccurrenceService } from '../../../core/services/occurrence/occurrences/occurrences.service'

@Component({
  selector: 'occurrence-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
  ],
  templateUrl: './occurrence-create.component.html',
  styleUrl: './occurrence-create.component.scss',
  providers: [EmployeeRoleService],
  standalone: true,
})
export class OccurrenceCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private employeeRoleService: EmployeeRoleService,
    private snackbar: SnackbarCustomService,
    private occurrenceService: OccurrenceService
  ) { }

  @Output() responseCreate = new EventEmitter()
  @Input() dataEdit: any

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()

  }


  createItem() {
    this.loading = true
    const model = this.createModel()
    this.occurrenceService.createOccurrence(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  editItem() {
    this.loading = true
    const descricao = this.createModel()
    const model = {
      id: this.dataEdit.id,
      descricao: descricao.descricao,
    }
    this.occurrenceService.editOccurrence(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      descricao: this.form.controls['description'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
    })
  }


}
